export function hasMotifType (image, type) {
  if (!image.hasOwnProperty('motifType') || image.motifType === null) {
    return false
  }
  return image.motifType.code === type
}

export function isRoomImage (image) {
  if (
    hasMotifType(image, 'BD') || hasMotifType(image, 'W')
    || hasMotifType(image, 'RV') || hasMotifType(image, 'RK')
  ) {
    return true
  }
  return false
}

export function hasImageRoomsAssigned (image) {
  if (!image.hasOwnProperty('rooms') || image.rooms.length === 0) {
    return false
  }
  return true
}

export function isImageConfirmed (image) {
  return (image.hasOwnProperty('confirmationTicket') &&
      typeof image.confirmationTicket === 'string')
    || image.confirmed
}
